interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`mb-8 md:mb-10 ${isCenter ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label font-medium tracking-widest uppercase text-primary-600">
        <span className="w-6 h-px bg-primary-400" />
        {eyebrow}
      </span>
      <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">{title}</h2>
      {desc ? <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p> : null}
    </div>
  );
}